import React from 'react';

import TeacherPayments from '../components/reports/TeacherPayments';


const ReportsPage = () => {
    return (<div><TeacherPayments /></div>)
}

export default ReportsPage;